(function () {
  var quickviewModal = document.getElementById('quickview-modal');
  var quickviewOverlay = document.getElementById('quickview-overlay');
  var quickviewContent = document.getElementById('quickview-content');
  var quickviewClose = document.getElementById('quickview-close');
  var selectedVariantId = null;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function openQuickView(button) {
    var handle = button.getAttribute('data-product-handle');
    var image = button.getAttribute('data-product-image') || '';

    quickviewContent.innerHTML = '<p class="quickview-loading">Loading…</p>';
    quickviewModal.classList.add('is-open');
    quickviewOverlay.classList.add('is-open');
    quickviewModal.setAttribute('aria-hidden', 'false');

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) { renderQuickView(product, image); })
      .catch(function () {
        quickviewContent.innerHTML = '<p>Failed to load. Please try again.</p>';
      });
  }

  function renderQuickView(product, image) {
    var variants = product.variants;
    selectedVariantId = variants[0].id;

    var optionsHtml = '';
    var hasRealOptions = !(product.options.length === 1 && product.options[0] === 'Title');

    if (hasRealOptions) {
      product.options.forEach(function (option, i) {
        var values = [];
        variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="quickview-option">';
        optionsHtml += '<label>' + escapeHtml(option) + '</label>';
        optionsHtml += '<div class="quickview-option-values">';
        values.forEach(function (val, idx) {
          optionsHtml += '<button type="button" class="quickview-option-btn' + (idx === 0 ? ' is-selected' : '') + '" data-option-index="' + i + '" data-option-value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</button>';
        });
        optionsHtml += '</div></div>';
      });
    }

    quickviewContent.innerHTML =
      '<img class="quickview-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '">' +
      '<div class="quickview-info">' +
        '<h3 class="quickview-title">' + escapeHtml(product.title) + '</h3>' +
        '<div class="quickview-options">' + optionsHtml + '</div>' +
        '<button type="button" class="quickview-add-btn" id="quickview-add-btn">Add to Cart</button>' +
      '</div>';

    quickviewContent.dataset.variants = JSON.stringify(variants);
  }

  function closeQuickView() {
    if (!quickviewModal) return;
    quickviewModal.classList.remove('is-open');
    quickviewOverlay.classList.remove('is-open');
    quickviewModal.setAttribute('aria-hidden', 'true');
  }

  // 事件代理：選項切換 + 加入購物車
  document.addEventListener('click', function (e) {
    // 觸發 Quick View
    var triggerBtn = e.target.closest('[data-quick-add]');
    if (triggerBtn) {
      var hasOnlyDefault = triggerBtn.getAttribute('data-has-only-default-variant') === 'true';
      if (!hasOnlyDefault) {
        e.preventDefault();
        e.stopPropagation();
        openQuickView(triggerBtn);
        return;
      }
    }

    // 選項按鈕
    var optBtn = e.target.closest('.quickview-option-btn');
    if (optBtn) {
      optBtn.closest('.quickview-option-values').querySelectorAll('.quickview-option-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      optBtn.classList.add('is-selected');

      var variants = JSON.parse(quickviewContent.dataset.variants || '[]');
      var selected = [];
      quickviewContent.querySelectorAll('.quickview-option-btn.is-selected').forEach(function (b) {
        selected[parseInt(b.getAttribute('data-option-index'))] = b.getAttribute('data-option-value');
      });
      var matched = variants.find(function (v) {
        return selected.every(function (val, i) {
          return v['option' + (i + 1)] === val;
        });
      });
      if (matched) selectedVariantId = matched.id;
    }

    // Quick View 加入購物車
    var addBtn = e.target.closest('#quickview-add-btn');
    if (addBtn && selectedVariantId) {
      addBtn.disabled = true;
      addBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          addBtn.textContent = '✓ Added';
          // 通知全站 cart 更新
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...data, silent: true }, bubbles: false }));

            // 單獨更新角標
            fetch('/cart.js')
              .then(function(res) { return res.json(); })
              .then(function(cart) {
                var badge = document.querySelector('.cart-icon-badge');
                if (badge) {
                  badge.textContent = cart.item_count;
                  if (cart.item_count > 0) {
                    badge.removeAttribute('hidden');
                  } else {
                    badge.setAttribute('hidden', '');
                  }
                }
              });

          setTimeout(function () {
            closeQuickView();
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }, 1000);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        });
    }

    // 關閉按鈕
    if (e.target.closest('#quickview-close') || e.target === quickviewOverlay) {
      closeQuickView();
    }
  });
})();
